import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import {
  eventsApi,
  publicEventsApi,
  publicPaymentsApi,
  bookCustomTicketForEventUser,
  paymentsApi,
} from 'src/app/services/constants/api.constants';
import { AuthService, HttpBaseService } from '@evento-ng/libs';
import { TicketService } from 'src/app/services/ticket.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-book-footer',
  templateUrl: './book-footer.component.html',
  styleUrls: ['./book-footer.component.scss'],
})
export class BookFooterComponent {
  tickets: any;
  showError = false;
  showErrorTime = false;
  showErrorCustomForm = false;
  showErrorinfoForm = false;
  invoiceId: any;
  showCartMobileFlag = false;
  @Input() eventId: any;
  @Input() customFormPageAppears = false;
  @Input() infoFormPageAppears = false;
  @Input() reviewPageAppears = false;
  @Input() backfromMobileCart: any;
  customFormObject: any;
  customFormFlag = false;
  isMobile = false;
  @Output() customForm = new EventEmitter<{}>();
  @Output() infoForm = new EventEmitter();
  @Output() review = new EventEmitter();
  @Output() showCartMobile = new EventEmitter(false);
  isSales = false;
  constructor(
    public ticketService: TicketService,
    public translateService: TranslateService,
    private router: Router,
    private recaptchaV3Service: ReCaptchaV3Service,
    private dataService: HttpBaseService,
    private authService: AuthService,
    private location: Location,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
  ) {
    if (window.screen.width <= 768) {
      this.isMobile = true;
    }
    if (this.router.url.includes('/sales/')) {
      this.isSales = true;
    }
  }

  ngOnInit() {
    this.getCustomForm();
  }

  ngOnChanges() {
    if (this.backfromMobileCart) {
      this.showCartMobileFlag = false;
    }
  }

  checkifAllValuesNull() {
    let valid = true;
    this.ticketService.bookTicket
      .getValue()
      ?.customForm?.values?.forEach((element: any) => {
        if (element.value) {
          console.log(element.value);
          valid = false;
        }
      });
    return valid;
  }

  payNow() {
    if (!this.isMobile) {
      if (
        this.ticketService.bookTicket.getValue()?.items?.length == 0 ||
        !this.ticketService.bookTicket.getValue()?.items
      ) {
        this.showError = true;
      } else if (!this.checkIfAllTimesSelected()) {
        this.showError = false;
        this.showErrorTime = true;
      } else if (
        this.customFormFlag &&
        !this.checkIfCustomFormAnswered() &&
        this.customFormPageAppears &&
        !this.infoFormPageAppears
      ) {
        this.showErrorCustomForm = true;
      } else if (this.customFormFlag && this.checkIfCustomFormAnswered()) {
        this.showErrorCustomForm = false;
        if (this.checkifAllValuesNull()) {
          this.customFormFlag = true;
          this.ticketService.updateBookTicket({
            customForm: null,
          });
        } else {
          this.submitAnswers();
        }
        this.customFormFlag = false;
        this.customFormPageAppears = false;
        this.showCartMobileFlag = false;
        this.review.emit();
        this.reviewPageAppears = true;
      } else if (
        !this.customFormPageAppears &&
        !this.infoFormPageAppears &&
        !this.reviewPageAppears
      ) {
        this.showError = false;
        this.showErrorTime = false;
        this.infoForm.emit();
        this.infoFormPageAppears = true;
      } else if (this.infoFormPageAppears && !this.checkIfInfoExists()) {
        this.showErrorinfoForm = true;
      } else if (this.infoFormPageAppears && this.checkIfInfoExists()) {
        this.showErrorinfoForm = false;
        this.infoFormPageAppears = false;
        this.showCartMobileFlag = false;
        if (this.customFormFlag) {
          this.customForm.emit(this.customFormObject);
          this.customFormPageAppears = true;
        } else {
          this.review.emit();
          this.reviewPageAppears = true;
        }
      } else if (
        this.customFormFlag &&
        !this.checkIfCustomFormAnswered() &&
        this.customFormPageAppears
      ) {
        this.showErrorCustomForm = true;
      } else if (this.reviewPageAppears) {
        this.ticketService.bookTicket.getValue().channel = 'ONLINE';
        this.createInvoice();
      }
    } else {
      this.payMobile();
    }
  }

  payMobile() {
    if (
      this.ticketService.bookTicket.getValue()?.items?.length == 0 ||
      !this.ticketService.bookTicket.getValue()?.items
    ) {
      this.showError = true;
    } else if (!this.showCartMobileFlag && !this.reviewPageAppears) {
      this.showError = false;
      this.showCartMobile.emit(true);
      this.showCartMobileFlag = true;
    } else if (!this.checkIfAllTimesSelected() && this.showCartMobileFlag) {
      this.showErrorTime = true;
    } else if (
      this.customFormFlag &&
      !this.checkIfCustomFormAnswered() &&
      this.customFormPageAppears &&
      !this.infoFormPageAppears
    ) {
      this.showErrorCustomForm = true;
    } else if (this.customFormFlag && this.checkIfCustomFormAnswered()) {
      this.showErrorCustomForm = false;
      if (this.checkifAllValuesNull()) {
        this.customFormFlag = true;
        this.ticketService.updateBookTicket({
          customForm: null,
        });
      } else {
        this.submitAnswers();
      }
      this.customFormFlag = false;
      this.customFormPageAppears = false;
      this.showCartMobileFlag = false;
      this.review.emit();
      this.reviewPageAppears = true;
    } else if (
      !this.infoFormPageAppears &&
      !this.reviewPageAppears &&
      !this.customFormPageAppears
    ) {
      this.showError = false;
      this.showErrorTime = false;
      this.infoForm.emit();
      this.infoFormPageAppears = true;
    } else if (this.infoFormPageAppears && !this.checkIfInfoExists()) {
      this.showErrorinfoForm = true;
    } else if (this.infoFormPageAppears && this.checkIfInfoExists()) {
      this.showErrorinfoForm = false;
      this.infoFormPageAppears = false;
      // this.showCartMobileFlag = false;
      if (this.customFormFlag) {
        this.customForm.emit(this.customFormObject);
        this.customFormPageAppears = true;
      } else {
        this.review.emit();
        this.reviewPageAppears = true;
      }
    } else if (this.reviewPageAppears) {
      this.ticketService.bookTicket.getValue().channel = 'ONLINE';
      this.createInvoice();
    }
  }

  submitAnswers() {
    const customForm = this.ticketService.bookTicket.getValue()?.customForm;
    delete customForm.isValid;
    customForm.values = customForm.values.filter((e: any) => {
      return e.value;
    });
    this.spinner.show();
    this.dataService
      .post(`${eventsApi}/${this.eventId}/forms/submit`, customForm)
      .subscribe((res) => {
        this.spinner.hide();
        this.ticketService.updateBookTicket({
          customFormSubmission: res.id,
        });
      });
  }

  checkIfAllTimesSelectedMobile() {
    let valid = true;
    this.ticketService.bookTicket.getValue()?.items?.map((item: any) => {
      if (item?.ticketSchedule?.timeSchedules.length > 0 && !item?.time) {
        valid = false;
      }
    });
    return valid;
  }
  checkIfAllTimesSelected() {
    let valid = true;
    if (this.isMobile && !this.showCartMobileFlag) {
      return true;
    } else {
      this.ticketService.bookTicket.getValue()?.items?.map((item: any) => {
        if (item?.ticketSchedule?.timeSchedules.length > 0 && !item?.time) {
          valid = false;
        }
      });
      return valid;
    }
  }

  checkIfCustomFormAnswered() {
    let valid = true;
    if (
      this.customFormObject.length > 0 &&
      !this.ticketService.bookTicket.getValue()?.customForm?.isValid
    ) {
      valid = false;
    }
    return valid;
  }

  checkIfInfoExists() {
    let valid = false;
    if (this.ticketService.bookTicket.getValue()?.info?.isValid) {
      valid = true;
    }
    return valid;
  }
  cancel() {
    {
      this.ticketService.bookTicket.next(null);

      this.router.navigateByUrl('/event-details/' + this.eventId);
    }
  }

  getCustomForm() {
    this.spinner.show();
    this.dataService
      .get(`${publicEventsApi}/${this.eventId}/custom-form`)
      .subscribe((res) => {
        this.spinner.hide();
        if (res.length == 0) {
          this.customFormFlag = false;
        } else {
          this.customFormObject = res;
          this.customFormFlag = true;
        }
      });
  }

  createInvoice() {
    this.spinner.show();
    const invoice = this.ticketService.bookTicket.getValue();
    this.recaptchaV3Service.execute('book').subscribe((token) => {
      const body = {
        channel: this.isSales ? 'ONLINE' : invoice.channel,
        customFormSubmission: invoice.customFormSubmission,
        event: this.eventId,
        items: invoice.items.map(
          (item: {
            ticketSchedule: any;
            ticket: { id: any };
            schedule: { id: any };
            time: { id: any };
          }) => {
            delete item.ticketSchedule;
            return {
              ...item,
              ticket: item.ticket.id,
              schedule: item.schedule.id,
              time: item.time?.id,
            };
          },
        ),
        metadata: {
          name: {
            first: invoice?.info?.firstName
              ? invoice.info.firstName
              : this.authService.user.getValue().firstName,
            last: invoice?.info?.lastName
              ? invoice.info.lastName
              : this.authService.user.getValue().lastName,
          },
          email: invoice?.info?.email
            ? invoice.info.email
            : this.authService.user.getValue().email,
          mobile: invoice.info.mobile.number
            ? invoice.info.mobile.number
            : this.authService.user.getValue().mobile,
          mobileRegionCode: invoice.info?.mobile
            ? invoice?.info?.mobile?.countryCode
            : // this.helpersService.extractCountryCode(
              this.authService.user.getValue().mobile,
          // ),
        },
        addonItems: invoice.addonItems || [],

        recaptchaToken: token,
        promoCodeId: invoice.promoCodeId,
      };
      let api;
      if (this.isSales) {
        api = bookCustomTicketForEventUser;
      } else {
        api = publicPaymentsApi;
      }
      this.dataService.post(`${api}`, body).subscribe((result) => {
        this.spinner.hide();
        if (result.status === 'PAID') {
          this.ticketService.bookTicket.next(null);
          if (this.isSales) {
            this.location.back();
          } else {
            this.router.navigateByUrl('/validate/' + result.id);
          }
        } else {
          if (this.isSales) {
            this.spinner.show();
            this.dataService
              .patch(`${paymentsApi}/${result.id}`, { channel: result.channel })
              .subscribe((res) => {
                this.spinner.hide();
                this.ticketService.bookTicket.next(null);
                this.location.back();
              });
          } else {
            this.invoiceId = result.id;
            const paymentUrl = `${environment.paymentRoot}?id=${result?.payment?.id}`;
            window.open(paymentUrl, '_self');
          }
        }
      });
    });
  }
}
